import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { PlayAudioButton } from 'components/flink-play';
import classes from './Item.module.scss';
import { s3bucketPublicURL } from 'config';

const Item = ({ data, contentFolder, activityAudioBaseUrl, disabled = false }) => {
  const { text, image, audio, audioPath } = data;
  const contentPath = activityAudioBaseUrl || `${s3bucketPublicURL}/${contentFolder}/gamedata/`;

  return (
    <div className={classnames(classes.item, 'order-it-mobile-item')}>
      {audio && (
        <PlayAudioButton
          url={(audioPath || contentPath) + audio}
          disabled={disabled}
          className={classnames({
            [classes.playAudioBtn]: !text && !image,
            [classes.playAudioBtnSmall]: text || image,
          })}
        />
      )}

      {text ? (
        <span className="order-it-mobile-item-text">{text}</span>
      ) : image ? (
        <img className={classnames(classes.itemImg, 'order-it-mobile-item-img')} src={contentPath + image} alt="" />
      ) : null}
    </div>
  );
};

Item.propTypes = {
  text: PropTypes.string,
  contentFolder: PropTypes.string.isRequired,
  activityAudioBaseUrl: PropTypes.string,
};

const mapStateToProps = ({ game }) => ({
  contentFolder: game.currentActivity.activity.contentFolder,
});

export default connect(mapStateToProps)(Item);
